module.exports = __webpack_public_path__ + "img/20190807163337478.e0ac3c89.png";